export const DELETE_SLIDER_REQUEST = 'DELETE_SLIDER_REQUEST';
export const DELETE_SLIDER_SUCCESS = 'DELETE_SLIDER_SUCCESS';
export const DELETE_SLIDER_FAILURE = 'DELETE_SLIDER_FAILURE';
